import React, { useContext as useContextHook } from 'react';
import { Dropdown } from 'semantic-ui-react';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import { LOCATION_SELECT_PLACEHOLDER } from './LocationSelect.constants';
import { getLocationDisplay, getLocationSelectOptions } from './LocationSelect.utils';
import { GoogleAnalytics } from '../../../../services/analytics';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../../analytics/components/Event';
import { LocationsContext } from '../../contexts/locations';
import { LocationPropType, LocationsPropType } from '../../types/location';
import './LocationSelect.css';
var defaultProps = {
  locations: [],
  activeLocation: {},
  setActiveLocation: null,
  useContext: false,
  search: true
};
export default function LocationSelect(_ref) {
  var locations = _ref.locations,
    activeLocation = _ref.activeLocation,
    setActiveLocation = _ref.setActiveLocation,
    useContext = _ref.useContext,
    search = _ref.search;
  var _useContextHook = useContextHook(LocationsContext),
    _useContextHook$locat = _useContextHook.locations,
    globalLocations = _useContextHook$locat === void 0 ? [] : _useContextHook$locat,
    _useContextHook$activ = _useContextHook.activeLocation,
    globalActiveLocation = _useContextHook$activ === void 0 ? {} : _useContextHook$activ,
    globalSetActiveLocation = _useContextHook.setActiveLocation,
    globalLoaded = _useContextHook.loaded;
  var finalLocations = useContext ? globalLocations : locations;
  var finalActiveLocation = useContext ? globalActiveLocation : activeLocation;
  var finalLoaded = useContext ? globalLoaded : true;
  var onLocationChange = useContext ? globalSetActiveLocation : setActiveLocation;
  var locationOptions = getLocationSelectOptions(finalLocations);
  if (_isEmpty(locationOptions) || locationOptions.length === 1) {
    return null;
  }
  if (!finalLoaded) {
    return null;
  }
  function onLocationChangeWrapper(e, _ref2) {
    var targetLocationId = _ref2.value;
    var location = _find(finalLocations, function (_ref3) {
      var id = _ref3.id;
      return id === targetLocationId;
    });
    onLocationChange(location);
    GoogleAnalytics.event(EVENT_CATEGORIES.LOCATION_EVENT_CATEGORY, EVENT_ACTIONS.LOCATION_TOGGLE_LOCATION_EVENT_ACTION, {
      label: getLocationDisplay(location)
    });
  }
  var currentSelectedOption = _find(locationOptions, function (_ref4) {
    var value = _ref4.value;
    return value === (finalActiveLocation === null || finalActiveLocation === void 0 ? void 0 : finalActiveLocation.id);
  });
  var trigger = /*#__PURE__*/React.createElement(Dropdown.Text, {
    "aria-hidden": true,
    className: "text ".concat(!(currentSelectedOption !== null && currentSelectedOption !== void 0 && currentSelectedOption.value) ? 'default' : '')
  }, (currentSelectedOption === null || currentSelectedOption === void 0 ? void 0 : currentSelectedOption.text) || LOCATION_SELECT_PLACEHOLDER);
  return /*#__PURE__*/React.createElement(Dropdown, {
    placeholder: LOCATION_SELECT_PLACEHOLDER,
    value: finalActiveLocation === null || finalActiveLocation === void 0 ? void 0 : finalActiveLocation.id,
    onChange: onLocationChangeWrapper,
    options: locationOptions,
    className: "location-select",
    search: search,
    closeOnChange: true,
    compact: true,
    selection: true,
    "aria-label": "Location Select",
    trigger: trigger
  });
}
LocationSelect.defaultProps = defaultProps;